var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Product"}},[_c('div',{ref:"wrapper",staticClass:"wrapper"},[(_vm.list.length > 0)?_c('product-list',{attrs:{"title":_vm.title,"list":_vm.list,"tabList":_vm.sortTabList},on:{"sortProduct":_vm.sortProduct}}):_c('no-product-list',{attrs:{"title":_vm.title}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }